// Internal modules
import { dispatchFormAction } from '@/store';
import { logger, ONBOARD_OPTION_CHANGED_PAYLOAD } from '@/lib';
import { appStore } from '@/store';

export const toggleOnboardOption = (option: string): void => {
  logger.fpti('onboard_option_changed', ONBOARD_OPTION_CHANGED_PAYLOAD(option));

  dispatchFormAction({
    field: 'onboardOption',
    payload: {
      displayError: false,
      error: '',
      errorCode: '',
      isDirty: true,
      isValid: true,
      value: option,
    },
  });
};

export const incrementCountToggle = (countToggles: number): void => {
  const { ui: uiActions } = appStore.getActions();
  uiActions.setCountToggles(countToggles + 1);
};
